import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { IUser } from '../../../interfaces/user';
import { Permission } from '../../../interfaces/permission.enum';

@Component({
    selector: 'app-search-tips',
    templateUrl: './search-tips.component.html',
    styles: [],
    standalone: false
})
export class SearchTipsComponent implements OnInit {
  public showVACORISTips: boolean = false;

  constructor(private readonly userService: UserService) { }

  ngOnInit() {
    let currentUser: IUser = this.userService.getCurrentUser();
    this.showVACORISTips = currentUser.permissions.includes(Permission.ViewVACORISNumber);
  }
}
